var _path, _path2, _path3, _rect, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1944 11.0273C25.4458 11.4655 28.6774 15.0474 28.6774 19.3212H22.8867V18.4969C22.8867 17.0636 21.8449 15.8737 20.4771 15.6431V11.4305C20.4771 11.1753 20.6979 10.9762 20.9517 11.0023L21.1944 11.0273Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0996 20.2144H11.3105V27.318C11.3105 32.1133 15.1979 36.0006 19.9932 36.0006C24.7885 36.0006 28.6758 32.1133 28.6758 27.318V20.2144H22.888V21.0378C22.888 22.6362 21.5923 23.932 19.9938 23.932C18.3954 23.932 17.0996 22.6362 17.0996 21.0378V20.2144Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3109 19.323C11.3109 15.0491 14.5425 11.4673 18.7939 11.0291L19.0366 11.0041C19.2904 10.9779 19.5112 11.1771 19.5112 11.4322V15.6448C18.1431 15.8751 17.1009 17.0652 17.1009 18.4987V19.323H11.3109Z",
    fill: "white",
    fillOpacity: 0.96
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.0625,
    y: 16.4883,
    width: 3.85895,
    height: 6.50832,
    rx: 1.92948,
    fill: "#BB86FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2866 5.26807L28.6394 6.94425C28.7868 7.01795 28.7869 7.22831 28.6395 7.30203L25.2867 8.97862C25.1537 9.04512 24.9972 8.94842 24.9972 8.79974L24.9972 7.62305L21.9971 7.62305C21.7209 7.62305 21.4971 7.39919 21.4971 7.12305C21.4971 6.8469 21.7209 6.62305 21.9971 6.62305L24.9972 6.62305L24.9972 5.44696C24.9972 5.29828 25.1537 5.20158 25.2866 5.26807ZM14.7104 8.97803L11.3576 7.30184C11.2102 7.22814 11.2102 7.01778 11.3576 6.94407L14.7104 5.26747C14.8434 5.20097 14.9999 5.29767 14.9999 5.44635L14.9999 6.62305L18 6.62305C18.2761 6.62305 18.5 6.8469 18.5 7.12305C18.5 7.39919 18.2761 7.62305 18 7.62305L14.9999 7.62305L14.9999 8.79914C14.9999 8.94781 14.8434 9.04451 14.7104 8.97803Z",
    fill: "white",
    fillOpacity: 0.96
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a7552134fce81c7b4843d0e40d656c0b.svg";
export { ForwardRef as ReactComponent };